import React from 'react';
import {
  AddListingToTourModal,
  OnboardingWelcomeModal,
  SetupBrokerageWizardModal,
  OnboardingPreLaunchModal,
  UserSuggestedUpdateModal,
  FeedbackModal,
  AppointmentActionModal,
  ContextualChatModal,
} from 'modals';

export default () => (
  <>
    <AddListingToTourModal />
    <OnboardingWelcomeModal />
    <SetupBrokerageWizardModal />
    <OnboardingPreLaunchModal />
    <UserSuggestedUpdateModal />
    <FeedbackModal />
    <AppointmentActionModal />
    <ContextualChatModal />
  </>
);
